import React from 'react'
import { mount } from '../utils/mount'
import { ProductBodifulLabPage, ProductShapeHipPage } from '../pages/product-page'

mount('#theme-product-page', <ProductShapeHipPage />)